// extracted by mini-css-extract-plugin
module.exports = {"squareContainer":"JobDetailTaskGraphic_squareContainer__1a8VL"};